import React from 'react';
import styled from 'styled-components';
import HeaderUser from './HeaderUser';

const StyledHeaderUser = styled(HeaderUser)``;

export default React.memo(StyledHeaderUser);
